import React from "react";
import { Toaster } from "react-hot-toast";

import AccessController from "_shared/AccessController";
import { DashGridL2 } from "layouts/dash-grid";
import TopBar from "_shared/Top";
import RolesManager from "./RolesManager";

// Admin Roles & Permissions page — full permission matrix (all dashboard pages).
const Main = () => <RolesManager />;

const RolesPage = () => {
  return (
    <AccessController roles={["ADMIN"]}>
      <DashGridL2 Top={TopBar} Main={Main} />
      <Toaster />
    </AccessController>
  );
};

export default RolesPage;
